export default "__VITE_ASSET__42262e9b__"